import React from 'react';
import QuoteBox from './QuoteBox';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/App.css';

function App() {
  return (
    <QuoteBox />
  );
}

export default App;
